import React, {Fragment} from 'react'
import _ from '/home/ps/root'
import {Toast, toast} from '../../master/toast'
import {eId} from '../../../global'
export const sanitize = (p, id) => {
  const min = 4
  const {cookie, uid} = p.master;
  const park = p.park
  const {db, v} = p
  const {pk} = p.table
  const {verb} = p.row
  const _username = eId(`${db}${v}${uid}${verb}username`) || cookie.username
  const username = _username?.value || _username

  const _password = eId(`${db}${v}${uid}${verb}password`)
  const password = _password?.value

  const _passwordAgain = eId(`${db}${v}${uid}${verb}passwordagain`)
  const passwordAgain = _passwordAgain?.value

  const _passwordCurrent = eId(`${db}${v}${uid}${verb}passwordcurrent`)
  const passwordCurrent = _passwordCurrent?.value

  const _name = eId(`${db}${v}${uid}${verb}name`) || cookie.name
  const name = _name?.value || _name

  // const _emailVerify = eId(`${db}${v}${uid}${verb}emailverify`)
  // const emailVerify = _emailVerify && _emailVerify.value

  const _email = eId(`${db}${v}${uid}${verb}email`) || park?.login?.user?.default?.[pk]?.email
  // const email = verb=='reset' ? _email : _email?.value
  const email = _email?.value || _email

  switch (verb) {
    case 'default':
    if (!username) return toast(`Username required.`)
    if (username.length < min) return toast(`Username invalid.`)
    if (!password) return toast(`Password required.`)
    if (password.length < min) return toast(`Password invalid.`)
    break

    case 'forget':
    if (!username) return toast(`Username required.`)
    if (username.length < min) return toast(`Username invalid.`)
    if (!password) return toast(`Password required.`)
    if (password.length < min) return toast(`Password invalid.`)
    if (!passwordAgain) return toast(`Password again required.`)
    if (password != passwordAgain) return toast(`Password don't match.`)
    if (!sanitizeEmail(email)) return
    break

    case 'insert':
    if (!username) return toast(`Username required.`)
    if (username.length < min) return toast(`Username invalid.`)
    if (!password) return toast(`Password required.`)
    if (password.length < min) return toast(`Password invalid.`)
    if (!passwordAgain) return toast(`Password again required.`)
    if (password != passwordAgain) return toast(`Password don't match.`)
    if (!name) return toast(`Name required.`)
    break

    case 'update':
    if (!passwordCurrent) return toast(`Password current required.`)
    if (!name) return toast(`Name required.`)
    break

    // case 'verify':
    // if (!passwordCurrent) return toast(`Password current required.`)
    // if (!emailVerify) return toast(`Email change required.`)
    // // if (emailVerify==email) return toast(`Email not change.`)
    // if (!sanitizeEmail(emailVerify, 'change')) return
    // break

    case 'reset':
    if (!passwordCurrent) return toast(`Password current required.`)
    if (!password) return toast(`Password required.`)
    if (password.length < min) return toast(`Password invalid.`)
    if (!passwordAgain) return toast(`Password again required.`)
    if (password != passwordAgain) return toast(`Password don't match.`)
  }
  switch (verb) {
    case 'default':
    case 'delete':
    break

    default:
    // if (verb!='reset' && !sanitizeEmail(email)) return
    if (!sanitizeEmail(email)) return
    if (id=='footer') {
      const _otp = eId(`${db}${v}${uid}${verb}otp`)
      const otp = _otp?.value
      if (!otp) return toast(`OTP required.`)
      if (otp.length<3 || isNaN(Number(otp))) return toast(`OTP invalid.`)
    }
  }
  return {verb, id: uid, email, username, user: cookie}
}

const sanitizeEmail = email => {
  if (!email) return toast(`Email required.`)
  const tok = email.split('@')
  if (
    tok.length!=2 ||
    !tok.every(t => t.length>0) ||
    !(tok[1].split('.').length>1) ||
    !(tok[1].split('.').every(t => t.length>0))
  ) return toast(`Email invalid.`)
  return 1
}
